module.exports = __webpack_public_path__ + "static/media/end-message.4626d7e8.png";